<template>
  <div>
    <h5 class="mb-3 mt-2">
      <b v-if="startPoint"
        >Seleziona il punto di partenza del sottoitinerario "{{ areaName }}"</b
      >
      <b v-else>Seleziona il luogo in cui pranzare</b>
    </h5>

    <div v-if="allLoaded">
      <treeselect
        v-model="value"
        :multiple="false"
        :options="options"
        :disable-branch-nodes="true"
        :show-count="true"
        :placeholder="
          startPoint ? 'Dove desideri parcheggiare?' : 'Dove desideri pranzare?'
        "
        :always-open="true"
        @input="checkStartPoint(0, null, false, value)"
      />
      <!-- <treeselect-value :value="value" /> -->
    </div>
    <div v-else>
      <div class="loader_filter">
        <svg class="circular">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="5"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
    </div>
    <!-- <div class="col-12">
      <p class="category">Sliders</p>
      {{ sliders.simple }}
      <slider
        v-model="sliders.simple"
        v-on:filter-by-distance="filterByDistance"
      >
      </slider>
    </div> -->

    <!-- <vue-cascader-select
      :options="options"
      @clear="(val) => (value = '')"
      @select="(selected) => (value = selected.value)"
      :value="value"
      style="z-index: 999"
    /> -->

    <!-- <div v-if="startPointsForThisAreaNotLoaded === false">
      <div v-if="startPointSelected !== ''">
        <div class="col-12">
          <div class="row">
            Punto di partenza selezionato: {{ startPointSelected }}
          </div>
          <div class="row">
            <Button @click="showStartPointOnMap()"
              >Visualizza punto sulla mappa</Button
            >
          </div>
        </div>
      </div>
      <div v-else>Nessun punto selezionato</div>
    </div> -->
    <!-- <div v-if="this.startPointsForEachArea.length > 0">
      <div
        v-for="(amenity, index) in amenities"
        :key="amenity.label"
        :class="index === 0 ? 'mt-3' : 'mt-2'"
      >
        <div v-if="getPointsOfCorrectType(amenity.tag).length > 0">
          <collapse>
            <collapse-item
              :title="amenity.label"
              :name="amenity.label"
              :isFilter="true"
            >
              <div class="filterDiv">
                <div
                  v-for="(point, index) in getPointsOfCorrectType(amenity.tag)"
                  :key="
                    amenity.tag +
                    ' ' +
                    point.POItitle +
                    ' - step ' +
                    currentStep
                  "
                >
                  <n-radio
                    :key="amenity.tag + ' ' + index"
                    v-model="startPointSelected"
                    :label="point.POItitle"
                    @input="
                      checkStartPoint(index, point, false, point.POItitle)
                    "
                    :name="point.POItitle"
                  >
                    {{ point.POItitle }}
                  </n-radio>
                </div>
              </div>
            </collapse-item>
          </collapse>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="loader_filter">
        <svg class="circular">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="5"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
    </div> -->
  </div>
</template>

<script src="./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js"></script>
<script>
const Common = require("@/Common.vue").default;

import {
  Checkbox,
  Radio,
  Collapse,
  CollapseItem,
  Slider,
  Modal,
  FormGroupInput,
} from "../";
import { Button } from "element-ui";

import VueCascaderSelect from "vue-cascader-select";

import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import VueSlider from 'vue-slider-component'
// import 'vue-slider-component/theme/material.css'

export default {
  props: [
    "amenities",
    "startPointSelectedProp",
    "startPointsForEachArea",
    "currentStep",
    "startPointsForThisAreaNotLoaded",
    "startPoint",
    "areaName",
  ],

  components: {
    [Radio.name]: Radio,
    Collapse,
    CollapseItem,
    Button,
    Treeselect,
    // VueCascaderSelect,
    Slider,
  },

  data() {
    return {
      sliders: {
        simple: 30,
        rangeSlider: [20, 60],
      },

      value: null,
      // define options
      options: [
        // {
        // //   id: "a",
        // //   label: "a",
        // //   children: [
        // //     {
        // //       id: "aa",
        // //       label: "aa",
        // //     },
        // //     {
        // //       id: "ab",
        // //       label: "ab",
        // //     },
        // //   ],
        // // },
        // // {
        // //   id: "b",
        // //   label: "b",
        // // },
        // // {
        // //   id: "c",
        // //   label: "c",
        // // },
      ],

      // amenities: [
      //   { tag: "parking", label: "Parcheggi" },
      //   { tag: "bar", label: "Bar" },
      //   { tag: "hospital", label: "Ospedali" },
      //   { tag: "station", label: "Stazioni" },
      //   { tag: "taxi", label: "Taxi" },
      //   { tag: "library", label: "Biblioteche" },
      // ],

      presentAmenities: [],
    };
  },

  created() {},

  mounted() {
    var self = this;

    console.log("this.startPointsForEachArea[this.currentStep]");
    console.log(this.startPointsForEachArea[this.currentStep]);


    if (this.startPointSelected !== "") {
      this.value = this.startPointSelected;
    } else {
      this.value = null;
    }

    this.initMultiSelect();
  },

  methods: {
    initMultiSelect() {
      this.presentAmenities = [
        ...new Set(
          this.startPointsForEachArea[this.currentStep].map((elem) => {
            return elem.type;
          })
        ),
      ];

      this.options = [];

      Array.prototype.forEach.call(this.presentAmenities, (amenityTag) => {
        var points = this.startPointsForEachArea[this.currentStep].filter(
          (elem) => {
            return elem.type === amenityTag;
          }
        );

        var amenityName = this.amenities.filter((elem) => {
          return elem.tag === amenityTag;
        })[0].label;

        var newAmenity = {
          id: amenityTag,
          label: amenityName,
          children: [],
        };

        Array.prototype.forEach.call(points, (point) => {
          newAmenity.children.push({
            id: point.POItitle,
            label: point.POItitle,
          });
        });

        this.options.push(newAmenity);
      });
    },
    getPointsOfCorrectType(amenityTag) {
      return this.startPointsForEachArea[this.currentStep].filter((elem) => {
        return elem.type === amenityTag;
      });
    },
    showStartPointOnMap() {
      this.$emit("showStartPointOnMap");
    },
    checkStartPoint(index, point, isFromMap, POIname) {
      this.$emit("checkStartPoint", index, point, isFromMap, POIname);
    },
    filterByDistance(e) {},
  },

  computed: {
    startPointSelected: {
      get() {
        return this.$props.startPointSelectedProp;
      },
      set(value) {
        //this.$emit("update:startPointSelectedProp", value);
      },
    },
    allLoaded() {
      return this.presentAmenities.length === this.options.length;
    },
  },

  watch: {
    startPointSelectedProp: function (newVal, oldVal) {
      if (newVal !== "") {
        this.value = newVal;
      } else {
        this.value = null;
        this.$emit("resetMarker", oldVal);
      }
    },
    currentStep: function (newVal, oldVal) {
      this.initMultiSelect();
    },
  },
};
</script>

<style >
.vcs__picker input {
  height: 50px !important;
}
</style>